// extracted by mini-css-extract-plugin
module.exports = {"breakpoints":"\"../../stylesheets/breakpoints.css\"","MD_SCREEN":"48em","container":"style_container__n6aMs"};